function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name, defaultVal) {
    let nameEQ = name + "=",
        ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }

    return defaultVal === undefined ? null : defaultVal;
}

function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Max-Age=-99999999;';
}

function populateUTMFields(utmForms) {
    let urlVars = getUrlVars();
    utmForms.forEach(function(formObj) {
        jQuery.each(urlVars, function(index, value) {
            if(index.includes('utm_')) {
                if(index == "utm_source") {
                    formObj.find('#form-field-utm_source').val(value);
                }
                else if(index == "utm_medium") {
                    formObj.find('#form-field-utm_medium').val(value);
                }
                else if(index == "utm_campaign") {
                    formObj.find('#form-field-utm_campaign').val(value);
                }
                else if(index == "utm_term") {
                    formObj.find('#form-field-utm_term').val(value);
                }
                else if(index == "utm_content") {
                    formObj.find('#form-field-utm_content').val(value);
                }                    
            } 
        });
    });
}

// From (modified): https://html-online.com/articles/get-url-parameters-javascript/
function getUrlVars() {
    let vars = {};
    let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
        vars[key] = value;
    });
    return vars;
}

function validateInternationalPhoneNumbers(fieldID) {
    jQuery(fieldID).on('input',function(){
        if (jQuery('span:contains("Please make sure the phone number is in")').length ) {
            let matches = jQuery('#form-field-phone').val().match(/^[0-9]{0,2}-?[0-9]{3}-?[0-9]{3}-?[0-9]{4}$/);
            if (matches != null) {
                jQuery('span:contains("Please make sure the phone number is in")').remove();
            }
        }
    }); 
}

function validateEmailAddress(fieldID) {
    jQuery(fieldID).on('input',function(){
        if (jQuery('span:contains("Please provide a valid email address")').length ) {
            let matches = jQuery('#form-field-email').val().match(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,4}$/);
            if (matches != null) {
                jQuery('span:contains("Please provide a valid email address")').remove();
            }
        }
    });
}